import sMallBuilding from "../../../images/unit/wizard/s-mall-building.svg"
import mediumBuilding from "../../../images/unit/wizard/medium-building.svg"
import lBuilding from "../../../images/unit/wizard/l-building.svg"
import xlBuilding from "../../../images/unit/wizard/xl-building.svg"
import sMallBuildingChosen from "../../../images/unit/wizard/s-mall-building-chosen.svg"
import mediumBuildingChosen from "../../../images/unit/wizard/medium-building-chosen.svg"
import lBuildingChosen from "../../../images/unit/wizard/l-building-chosen.svg"
import xlBuildingChosen from "../../../images/unit/wizard/xl-building-chosen.svg"
import young from "../../../images/unit/wizard/young.svg"
import youngChosen from "../../../images/unit/wizard/youngChosen.svg"
import student from "../../../images/unit/wizard/students.svg"
import studentsChosen from "../../../images/unit/wizard/studentsChosen.svg"
import family from "../../../images/unit/wizard/family.svg"
import familyChosen from "../../../images/unit/wizard/familyChosen.svg"
import elders from "../../../images/unit/wizard/elders.svg"
import eldersChosen from "../../../images/unit/wizard/eldersChosen.svg"
import { population } from "../items"

export const titleWizard = {
  "propertySize": {
    "residential": "What is the size of the property?",
    "studentHousing": "How many beds do you have?",
    "community": "How many people are in your distribution?",
    "office": "How many employees in the office?",
    "hospitality": "Which groups best categorize your tenants?"
  },
  "population": {
    "residential": "Which groups best categorize your tenants?",
    "studentHousing": "Which groups best categorize your tenants?",
    "community": "What is you type of place?",
    "office": "How would you describe the type of office?",
    "hospitality": "How would you describe the style of hospitality?"
  }
}

export const questionsWizard = {
  "propertySize": {
    "residential": [
      { "title": "Up to 100 units", "image": sMallBuilding, "chosen": sMallBuildingChosen, "key": "100-200" },
      { "title": "100-200 units", "image": mediumBuilding, "chosen": mediumBuildingChosen, "key": "200-400" },
      { "title": "200-500 units", "image": lBuilding, "chosen": lBuildingChosen, "key": "400-800" },
      { "title": "500+ units", "image": xlBuilding, "chosen": xlBuildingChosen, "key": "800+" }
    ],
    "studentHousing": [
      { "title": "100-200 students", "image": sMallBuilding, "chosen": sMallBuildingChosen, "key": "100-200" },
      { "title": "200-400 students", "image": mediumBuilding, "chosen": mediumBuildingChosen, "key": "200-400" },
      { "title": "400-800 students", "image": lBuilding, "chosen": lBuildingChosen, "key": "400-800" },
      { "title": "800+ students", "image": xlBuilding, "chosen": xlBuildingChosen, "key": "800+" }
    ],
    "community": [
      { "title": "100-1000", "image": sMallBuilding, "chosen": sMallBuildingChosen, "key": "100-200" },
      { "title": "1000-5000", "image": mediumBuilding, "chosen": mediumBuildingChosen, "key": "200-400" },
      { "title": "5000-10000", "image": lBuilding, "chosen": lBuildingChosen, "key": "400-800" },
      { "title": "10000+", "image": xlBuilding, "chosen": xlBuildingChosen, "key": "800+" }
    ],
    "office": [
      { "title": "100-200", "image": sMallBuilding, "chosen": sMallBuildingChosen, "key": "100-200" },
      { "title": "200-400", "image": mediumBuilding, "chosen": mediumBuildingChosen, "key": "200-400" },
      { "title": "400-800", "image": lBuilding, "chosen": lBuildingChosen, "key": "400-800" },
      { "title": "800+", "image": xlBuilding, "chosen": xlBuildingChosen, "key": "800+" }
    ],
    "hospitality": [
      { "title": "Up to 100 units", "image": sMallBuilding, "chosen": sMallBuildingChosen, "key": "100-200" },
      { "title": "100-200 units", "image": mediumBuilding, "chosen": mediumBuildingChosen, "key": "200-400" },
      { "title": "200-500 units", "image": lBuilding, "chosen": lBuildingChosen, "key": "400-800" },
      { "title": "500+ units", "image": xlBuilding, "chosen": xlBuildingChosen, "key": "800+" }
    ]
  },
  "population": {
    "residential": [
      { title: "Young Professionals", image: young, chosen: youngChosen, key: population.youngProfessionals },
      { title: "Students", image: student, chosen: studentsChosen, key: population.students },
      { title: "Families", image: family, chosen: familyChosen, key: population.families },
      { title: "Elders", image: elders, chosen: eldersChosen, key: population.elders }
    ],
    "studentHousing": [
      { title: "Postgraduate", image: young, chosen: youngChosen, key: population.postgraduate },
      { title: "Undergraduate", image: student, chosen: studentsChosen, key: population.undergraduate },
      { title: "Other", image: family, chosen: familyChosen, key: population.other }
    ],
    "community": [
      { title: "Community center", image: young, chosen: youngChosen, key: population.communityCenter },
      { title: "Neighborhood", image: student, chosen: studentsChosen, key: population.neighborhood },
      { title: "municipality", image: family, chosen: familyChosen, key: population.municipality },
      { title: "Other", image: elders, chosen: eldersChosen, key: population.other }
    ],
    "office": [
      { title: "Shared office", image: young, chosen: youngChosen, key: population.sharedOffice },
      { title: "Corporate", image: student, chosen: studentsChosen, key: population.corporate },
      { title: "Startup", image: family, chosen: familyChosen, key: population.startup },
      { title: "Office building", image: elders, chosen: eldersChosen, key: population.officeBuilding }
    ],
    "hospitality": [
      { title: "Hotel", image: young, chosen: youngChosen, key: population.hotel },
      { title: "Hostel", image: student, chosen: studentsChosen, key: population.hostel },
      { title: "Extended stays", image: family, chosen: familyChosen, key: population.extendedStays }
    ]
  }
}
